<div class="flex flex-col h-full">
  <div class="flex gap-3 items-center">
    <!-- Load Case Selector -->
    <div class="mb-1">
      <p-select 
        inputId="load-case-select"
        class="w-40"
        [ngModel]="selectedLoadCase()"
        (ngModelChange)="selectedLoadCase.set($event); onDisplayModeOrLoadCaseChange()"
        [options]="loadCases()"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Load Case"
        appendTo="body"
        pTooltip="Load Case"
      ></p-select>
    </div>

    <!-- Display Mode Selector -->
    <div class="mb-1">
      <p-select 
        [ngModel]="displayMode()"
        (ngModelChange)="displayMode.set($event); onDisplayModeOrLoadCaseChange()"
        [options]="displayModeOptions" 
        optionLabel="label" 
        optionValue="value"
        class="w-full"
        placeholder="Select Display Mode"
        pTooltip="Display Mode"
      ></p-select>
    </div>

    @if (showExpansionJointFocusToggle()) {
      <div class="mb-1 flex items-center gap-2">
        <p-selectButton
          [ngModel]="expansionJointFocus()"
          (ngModelChange)="expansionJointFocus.set($event); onExpansionJointFocusChange()"
          [options]="expansionJointFocusOptions"
          optionLabel="label"
          optionValue="value"
          ariaLabel="Expansion joint focus"
          [allowEmpty]="false"
        ></p-selectButton>
        <i
          class="pi pi-info-circle text-muted-color cursor-help"
          pTooltip="Shown only for true telescoping expansion joints (EJ enabled and depth set away from packer depth)."
        ></i>
      </div>
    }

    <div class="flex justify-end pb-2">
      <p-button
        text
        size="small"
        icon="pi pi-download"
        pTooltip="Download as PNG"
        (click)="onExportPng()"
      ></p-button>
    </div>
  </div>

  <!-- Schematic Display -->
  <div #schematicContainer 
       class="schematicContainer flex-1 border rounded-lg bg-surface-0 min-h-0"
       [class.panning]="isPanning()"
       pTooltip="Scroll to Zoom, Drag to Pan, Double-click to Reset, Right-click to Copy"
       (dblclick)="resetView()"
       (contextmenu)="onPackerContextMenu($event)"
       (mousewheel)="onMouseWheel($event)"
       (mousedown)="onMouseDown($event)"
       (mouseup)="onMouseUp()"
       (mousemove)="onMouseMove($event)">
    <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true" class="h-full">
      @if (errorMessage()) {
        <div class="text-red-500 p-4 text-center">
          <i class="pi pi-exclamation-triangle mr-2"></i>
          {{ errorMessage() }}
        </div>
      }

      @if (!errorMessage() && svgContent()) {
        <div
          class="w-full h-full"
          [innerHTML]="svgContent() | sanitizeHtml"
        ></div>
      }

      @if (!errorMessage() && !svgContent() && !isLoading()) {
        <div class="text-muted-color p-4 text-center">
          <i class="pi pi-info-circle mr-2"></i>
          Select a packer to view schematic
        </div>
      }
    </app-tool-loader>
  </div>

  <p-contextMenu #packerCm [model]="packerContextMenuItems()" appendTo="body"></p-contextMenu>
</div>